import { Chip } from '@/components/commons/chip'
import { ImageCard } from '@/components/commons/image-card'
import { Image01Icon, Stars01Icon } from '@/components/ui/icons'
import type { PhotosetSpace } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'
import { SpaceImagesContainer } from '../space-images-atoms'

export const RetouchingRevisionSpaceImages = ({
	images,
	isLoadingManualRetouchingSpaces
}: {
	images: PhotosetSpace['images']
	isLoadingManualRetouchingSpaces: boolean
}) => {
	const { t } = useTranslation()

	return (
		<SpaceImagesContainer $gap={4}>
			{images.map((image) => {
				const thumbnail =
					image.revised_thumbnails?.xs ||
					image.retouched_thumbnails?.xs ||
					image.ai_retouched_thumbnails?.xs
				return (
					<ImageCard
						badgeType='to_revise'
						endSlot={
							!isLoadingManualRetouchingSpaces && (
								<>
									{image.is_revised && (
										<Chip
											isActive={true}
											label={t(
												'photoset:retouching_revision.retouching_revised'
											)}
											variant={'info'}
										/>
									)}

									{image.needs_to_review &&
										!image.is_revised && (
											<Chip
												isActive={true}
												label={t(
													'photoset:retouching_revision.not_revised'
												)}
												variant={'danger'}
											/>
										)}
								</>
							)
						}
						hideCheckbox={true}
						image={image}
						imageNameIcon={
							image.is_manually_retouched ? (
								<Image01Icon size={20} />
							) : (
								<Stars01Icon size={20} />
							)
						}
						isLoading={false}
						isSelected={false}
						key={image.id}
						loadingText={t('common:generating_thumbnails')}
						showBadge={
							!!(
								image.revised_thumbnails?.xs &&
								image.needs_to_review
							)
						}
						thumbnail={thumbnail}
					/>
				)
			})}
		</SpaceImagesContainer>
	)
}
